<template>
  <div class="competitiveAdvantageSlider">
    <div><img src="https://d24qrurc3qms3u.cloudfront.net/core/images/Green-Squared-Certified.png"></div>
    <div><img src="https://d24qrurc3qms3u.cloudfront.net/core/images/DCOF-Acutest.png"></div>
    <div><img src="https://d24qrurc3qms3u.cloudfront.net/core/images/Greenguard-gold.png"></div>
    <div><img src="https://d24qrurc3qms3u.cloudfront.net/core/images/Certified-Porcelain.png"></div>
    <div><img src="https://d24qrurc3qms3u.cloudfront.net/core/images/Florida-Tile-mindful-materials.png"></div>
    <div><img src="https://d24qrurc3qms3u.cloudfront.net/core/images/Florida-Tile-recycle.png"></div>
    <div><img src="https://d24qrurc3qms3u.cloudfront.net/core/images/Made-in-USA.png"></div>
    <div><img src="https://d24qrurc3qms3u.cloudfront.net/core/images/Rectified.png"></div>
    <div><img src="https://d24qrurc3qms3u.cloudfront.net/core/images/Green-Squared-Certified.png"></div>
    <div><img src="https://d24qrurc3qms3u.cloudfront.net/core/images/DCOF-Acutest.png"></div>
    <div><img src="https://d24qrurc3qms3u.cloudfront.net/core/images/Greenguard-gold.png"></div>
    <div><img src="https://d24qrurc3qms3u.cloudfront.net/core/images/Certified-Porcelain.png"></div>
    <div><img src="https://d24qrurc3qms3u.cloudfront.net/core/images/Florida-Tile-mindful-materials.png"></div>
    <div><img src="https://d24qrurc3qms3u.cloudfront.net/core/images/Florida-Tile-recycle.png"></div>
    <div><img src="https://d24qrurc3qms3u.cloudfront.net/core/images/Made-in-USA.png"></div>
    <div><img src="https://d24qrurc3qms3u.cloudfront.net/core/images/Rectified.png"></div>
    <div><img src="https://d24qrurc3qms3u.cloudfront.net/core/images/bureau-vertias.png"></div>
    <div><img src="https://d24qrurc3qms3u.cloudfront.net/core/images/eco-scorecard.jpg"></div>
    <div><img src="https://d24qrurc3qms3u.cloudfront.net/core/images/hpdc.png"></div>
    <div><img src="https://d24qrurc3qms3u.cloudfront.net/core/images/Declare-logo.png"></div>
  </div>
</template>


<script>
  import { tns } from "tiny-slider/src/tiny-slider"
  export default {
    data() {
      competitiveAdvantageSlider: null
    },
    mounted() {
      this.competitiveAdvantageSlider = tns({
      container: '.competitiveAdvantageSlider',
      loop: true,
      autoplay: true,
      autoplayHoverPause: true,
      autoplayButtonOutput: false,
      controls: false,
      nav: false,
      speed: 2500,
      autoplayTimeout: 0,
      preventActionWhenRunning: true,
      mouseDrag: true,
      responsive: {
        320: {
          items: 1,
          mouseDrag: true,
        },
        320: {
          items: 2,
        },
        767: {
          items: 3,
        },
        991: {
          items: 4,
        },
        1199: {
          items: 5,
        },
        1400: {
          items: 7,
        },
        
      }
    });
    },
    destroyed() {
    },
    methods: {

    },
  };
</script>

<style>
.competitiveAdvantageSlider {
    margin-top: 75px;
}

.competitiveAdvantageSlider div {
    text-align: center;
}

#tns1 {
    /*transition-duration: 3s !important;*/
    transition-timing-function: linear !important;
}
</style>


// WEBPACK FOOTER //
// core/vue/components/LogoCarousel.vue